export default function matchesType(targetType, draggedItemType) {
  if (draggedItemType === null) {
    return targetType === null;
  }

  return Array.isArray(targetType) ? targetType.some(function (t) {
    return t === draggedItemType;
  }) : targetType === draggedItemType;
}


//////////////////
// WEBPACK FOOTER
// ./~/dnd-core/dist/esm/utils/matchesType.js
// module id = 243
// module chunks = 4